import Repository from '@/repositories/marketing'
const resource = '/tags'

export default {
    show(tagId, config) {
        return Repository.get(`${resource}/${tagId}`,config)
    },
    update(tagId,payload,config){
        return Repository.put(`${resource}/${tagId}`,payload, config)
    },
    deleteLink(tagId,config){
        return Repository.delete(`${resource}/${tagId}/remove_tag_link.json`,config)
    },
    addNewLink(tagId,payload,config){
        return Repository.post(`${resource}/${tagId}/create_tag_link.json`,payload,config)
    },
    updateLink(tagId,payload,config){
        return Repository.put(`${resource}/${tagId}/update_tag_link.json`,payload,config)
    },
    fetch (config) {
        return Repository.get(`${resource}.json`, config)
    },
    create (payload, config) {
        return Repository.post(`${resource}.json`, payload, config)
      },
    delete (config) {
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    import (payload, config) {
        return Repository.post(`${resource}/import.json`, payload, config)
    },
}
